import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './router';
import apis from 'api/index';
import store from '@/store/index';
import { deleteString } from 'common/js/utils.js';

Vue.use(VueRouter)

/**
 * 路由配置
 */
const RouterConfig = {
  mode: 'history', //去掉#，
  base: '/webview/billing-app/',
  routes: routes
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to,from,next) => {
  if (to.query.token) {
    store.state.token = to.query.token;
    apis.setToken(to.query.token);
  }
  const userAllInfo = store.state.userAllInfo;
  if(JSON.stringify(userAllInfo) !== '{}') {
    next();
  } else {
    store.dispatch('fetchDictTree').then(() => {
      store.dispatch('fetchBaseInfo').then(() => {
        next();
      });
    });
  }
})

export default router;